import { Type } from 'class-transformer';
import { BaseEntity, LanguageCode } from '@models';
import { User } from '../user';

export class UserPreferences extends BaseEntity {
	userEmail: string;

	@Type(() => User)
	user: User;

	language: LanguageCode;
}
